import script from "./CUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./CUpload.vue?vue&type=script&setup=true&lang=ts"

import "./CUpload.vue?vue&type=style&index=0&id=33e9e063&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e9e063"]])

export default __exports__